<template>
  <validated-form :message="fieldFormMessage" @submit="handleFormSubmit">
    <mdb-input
      v-model="fieldData.name"
      size="lg"
      label="Field No."
      type="text"
      outline
      required
    />
    <mdb-input
      v-model="fieldData.arces"
      size="lg"
      label="Arces"
      type="number"
      outline
    />
    <mdb-input
      v-model="fieldData.type"
      size="lg"
      label="Field Type"
      type="text"
      outline
    />
    <div class="form-check">
      <input
        id="isActiveCheckbox"
        v-model="fieldData.isActive"
        type="checkbox"
        class="form-check-input"
      />
      <label class="form-check-label pl-2" for="isActiveCheckbox">Is Active?</label>
    </div>
    <mdb-btn color="primary" type="submit" class="float-right">
      Save
    </mdb-btn>
  </validated-form>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import ValidatedForm from "./ValidatedForm";
import { fieldsModel } from "../models/field";

export default {
  name: "FarmFieldForm",
  components: {
    mdbInput,
    mdbBtn,
    ValidatedForm
  },
  props: {
    farmId: {
      type: String,
      default: ""
    },
    fieldId: {
      type: String,
      default: ""
    },
    fieldData: {
      type: Object,
      default: function() {
        return {
          farmId: "",
          farmName: "",
          name: "",
          arces: 0,
          type: "",
          services: [],
          isActive: true,
        };
      }
    }
  },
  data() {
    return {
      fieldFormMessage: {}
    };
  },
  methods: {
    handleFormSubmit() {
      this.fieldFormMessage = {};
      fieldsModel
        .update(this.fieldId, this.fieldData)
        .then(() => {
          this.fieldFormMessage = {
            type: "success",
            message: "Field Saved!"
          };
          this.$emit("savedField");
        })
        .catch(() => {
          this.fieldFormMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    }
  }
};
</script>
